import axios from "axios";
import { TodoDashboardApi } from ".";

export const fetchToDoList = ({ params }) => {
  return axios
    .get(`${TodoDashboardApi}`, { params: { ...params } })
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};
